// extracted by mini-css-extract-plugin
export default {"form":"FormComponent_form__c8Hwn","form__text":"FormComponent_form__text__zLK5G","form__btn":"FormComponent_form__btn__QM9Y3"};